






























































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import moment from 'moment'
import BackofficeAgendamentoStore from '@/components/Backoffice/Store/BackofficeAgendamentoStore'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import SolicitacaoPendenciaStore from '@/components/SolicitacaoPendencia/Store/SolicitacaoPendenciaStore'
import SolicitacaoCancelamentoStore from '@/components/SolicitacaoCancelamento/Store/SolicitacaoCancelamentoStore'
import HistoricoSolicitacaoStore from '@/components/HistoricoSolicitacao/Store/HistoricoSolicitacaoStore'
import SolicitacaoComentariosStore from '@/components/SolicitacaoComentarios/Store/SolicitacaoComentariosStore'
import ReservaSalaStore from '@/components/ReservaSala/Store/ReservaSalaStore'
import BackofficeMapaCirurgicoGradeStore from '@/components/Backoffice/Store/BackofficeMapaCirurgicoGradeStore'
import { TipoUsuarioEnum, CancelarSolicitacaoParam, TipoOrigemEnum, RequestMessage, PendenciaMensagem, TipoMensagemEnum, TipoDocumentoUpload } from '@/types/_'
import { timeout, timeoutDefault, groupCollectionByField, maskHour, caraterCirurgiaMap, solicitacaoStatusSituacaoMap, maskDateTime } from '@/utils/common'
import { IPendenciaSolicitacao, PendenciaSolicitacao } from '@/types/implements/PendenciaSolicitacao'
import { Triagem, ITriagem } from '@/types/implements/Triagem'
import EventBus from '@/plugins/EventBus'
import Chat from '@/views/backoffice-chat/chat/chat.vue'
import BackofficeModalChatStore from '@/views/backoffice-chat/store/backoffice-modal-chat-store'
import ModalBackofficeNacionalidade from '@/components/Backoffice/modais/ModalBackofficeNacionalidade.vue'

@Component({
  components: {
    Chat,
    ModalBackofficeNacionalidade,
  },
})
export default class ComponentModalTriagem extends Vue {
  $refs!: {
    refConfirmarTriagem: any,
    pendencia: any,
    refConfirmarPendencia: any,
    modalContainer: HTMLElement,
    modalBackofficeNacionalidade: any,
  }

  tipoAutorizacaoAnexo: any = {
    pedidoMedico: true,
    laudo: true,
    cotacaoOpme: true,
    laudoAnestesista: false,
    anexoOperadora: false,
    resumo: true,
  }

  tipoUsuario: TipoUsuarioEnum = TipoUsuarioEnum.Hospital

  step: number = 1
  modalPendencia: boolean = false
  modalConfirmarPendencia: boolean = false
  loadPendencia: boolean = false
  loadHistorico: boolean = false
  loadComentarios: boolean = false
  loadNextStep: boolean = false
  loadCancelamento: boolean = false
  loadClose: boolean = false
  loadMensagem: boolean = false
  loadUpload: boolean = false
  loadConfirmarPendencia: boolean = false
  loadCloseConfirmarPendencia: boolean = false
  loadClosePedencia: boolean = false
  loadConfirmar: boolean = false
  loadCloseBnt: boolean = false
  disableConfirmarTriagem: boolean = true

  pendenciaSolicitacao: IPendenciaSolicitacao = new PendenciaSolicitacao()
  triagem: ITriagem = new Triagem()

  mensagem: string = ''
  inputFiles: any[] = []

  get getDisableConfirmarTriagem() {
    return this.disableConfirmarTriagem
  }

  set getDisableConfirmarTriagem(value: boolean) {
    this.disableConfirmarTriagem = value
  }

  get loadingCloseBtn() {
    return this.loadCloseBnt
  }

  set loadingCloseBtn(val: boolean) {
    this.loadCloseBnt = val
  }

  get loadingConfirmar() {
    return this.loadConfirmar
  }

  set loadingConfirmar(val: boolean) {
    this.loadConfirmar = val
  }

  get loadingClosePendencia() {
    return this.loadClosePedencia
  }

  set loadingClosePendencia(value: boolean) {
    this.loadClosePedencia = value
  }

  get loadingCloseConfirmarPendencia() {
    return this.loadCloseConfirmarPendencia
  }

  set loadingCloseConfirmarPendencia(val: boolean) {
    this.loadCloseConfirmarPendencia = val
  }

  get loadingConfirmarPendencia() {
    return this.loadConfirmarPendencia
  }

  set loadingConfirmarPendencia(val: boolean) {
    this.loadConfirmarPendencia = val
  }

  get showModalConfirmarPendencia() {
    return this.modalConfirmarPendencia
  }

  set showModalConfirmarPendencia(value: boolean) {
    this.modalConfirmarPendencia = value
  }

  get loadingUpload() {
    return this.loadUpload
  }

  set loadingUpload(val: boolean) {
    this.loadUpload = val
  }

  get loadingMensagem() {
    return this.loadMensagem
  }

  set loadingMensagem(val: boolean) {
    this.loadMensagem = val
  }

  get getMensagem() {
    return this.mensagem
  }

  set getMensagem(texto: string) {
    this.mensagem = texto
  }

  get getDisplayPendencia() {
    return { nomePaciente: this.getBackofficeGlobalStore.solicitacao.paciente.nome,
      nomeMedico: this.getBackofficeGlobalStore.solicitacao.medicoSolicitante.nome }
  }

  get getStep() {
    return this.step
  }

  set getStep(value: number) {
    this.step = value
  }

  get loadingClose() {
    return this.loadClose
  }

  set loadingClose(value: boolean) {
    this.loadClose = value
  }

  get loadingCancelamento() {
    return this.loadCancelamento
  }

  set loadingCancelamento(value: boolean) {
    this.loadCancelamento = value
  }

  get loadingNextStep() {
    return this.loadNextStep
  }

  set loadingNextStep(value: boolean) {
    this.loadNextStep = value
  }

  get loadingPendencia() {
    return this.loadPendencia
  }

  set loadingPendencia(value: boolean) {
    this.loadPendencia = value
  }

  get loadingHistorico() {
    return this.loadHistorico
  }

  set loadingHistorico(value: boolean) {
    this.loadHistorico = value
  }

  get loadingComentarios() {
    return this.loadComentarios
  }

  set loadingComentarios(value: boolean) {
    this.loadComentarios = value
  }

  get showModalPendencia() {
    return this.modalPendencia
  }

  set showModalPendencia(value: boolean) {
    this.modalPendencia = value
  }

  get getHistoricoSolicitacaoStore() {
    return getModule(HistoricoSolicitacaoStore, this.$store)
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getBackofficeAgendamentoStore() {
    return getModule(BackofficeAgendamentoStore, this.$store)
  }

  get getPendenciaStore() {
    return getModule(SolicitacaoPendenciaStore, this.$store)
  }

  get getSolicitacaoCancelamentoStore() {
    return getModule(SolicitacaoCancelamentoStore, this.$store)
  }

  get getComentariosStore() {
    return getModule(SolicitacaoComentariosStore, this.$store)
  }

  get getReservaSalaStore() {
    return getModule(ReservaSalaStore, this.$store)
  }

  get getBackofficeMapaCirurgicoGradeStore() {
    return getModule(BackofficeMapaCirurgicoGradeStore, this.$store)
  }

  get getTipoConfirmacao() {
    return TipoOrigemEnum.Triagem
  }

  get getRequestMessage() {
    return new RequestMessage()
  }

  get showModalTriagem() {
    const show = this.getBackofficeGlobalStore.modal.triagem
    this.toggleHtmlOverflow(show)
    this.scrollToMensagem()

    return show
  }

  set showModalTriagem(value) {
    this.getBackofficeGlobalStore.setModal({ name: 'triagem', value })
  }

  get getMensagens() {
    return this.getPendenciaStore.pendencia.mensagens
  }

  get getTipoMensagemEnum() {
    return TipoMensagemEnum
  }

  get getPedidoMedico() {
    const anexos: any[] = []
    if (this.getBackofficeGlobalStore.solicitacao.url) {
      anexos.push({ url: this.getBackofficeGlobalStore.solicitacao.url, nomeOriginalArquivo: 'Pedido médico' })
    }
    return anexos
  }

  get backofficeModalChatStore() {
    return getModule(BackofficeModalChatStore, this.$store)
  }

  groupByDate(value: any) {
    return groupCollectionByField(value)
  }

  formatHour(value: string) {
    return maskHour(value)
  }

  get canInvalidateSignature() {
    if (this.getBackofficeGlobalStore.solicitacao.situacao.key === 'NovaSolicitacaoDeOrcamentoParticularAvulso') return false
    return this.getBackofficeGlobalStore.solicitacao.laudos.length > 0 || this.getPedidoMedico.length > 0
  }

  async openChat() {
    const chatData = {
      solicitationId: this.getBackofficeGlobalStore.solicitacao.id,
      chatArea: 'agendamento',
      recipientName: this.getBackofficeGlobalStore.solicitacao.medicoSolicitante.nome,
      senderId: this.$user.profile.sub,
      senderName: this.$user.profile.name,
    }

    this.backofficeModalChatStore.reset()
    await this.backofficeModalChatStore.openChatModal(chatData)
  }

  get temPendenciaDePacientePais() {
    return !!this.getBackofficeGlobalStore.solicitacao.temPendenciaDePacientePais
  }

  async nextStep(step) {
    this.loadingNextStep = true
    const { solicitacao, componentToConfirmReservation } = this.getBackofficeGlobalStore
    // 1. Se houver mensagem de pendência a ser tratada...
    if (this.getPendenciaStore.pendencia.mensagens.length > 0) {
      this.showModalConfirmarPendencia = true
      this.loadingNextStep = false
      return
    }

    // 2. Se a solicitação segue o fluxo de Nova Solicitacão Particular ou Nova solicitação de orçamento particular avulso..
    if (!solicitacao.acoes.agendamentoFazReservaDeSalaParticular
      && ['NovaSolicitacaoParticular', 'NovaSolicitacaoDeOrcamentoParticularAvulso'].includes(this.getBackofficeGlobalStore.solicitacao.situacao.key)
      && !solicitacao.acoes.agendamentoInformaReservaEmSolicitacaoParticular
    ) {
      const response = await this.getBackofficeGlobalStore.finalizarTriagemParticular()
      if (response.success) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Triagem efetuada com sucesso!', icon: 'done', color: '#2E7D32' })
        await this.closeModal()
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: 'Ocorreu um erro ao efetuar a triagem.', icon: 'warning', color: '#C62828' })
      }

      this.loadingNextStep = false
      return
    }

    // 3. Se o paciente tem pendência de país...
    if (this.temPendenciaDePacientePais) {
      this.$refs.modalBackofficeNacionalidade.$refs.formNacionalidade.resetValidation()
      this.getBackofficeGlobalStore.setModal({ name: 'pais', value: true })
      this.loadingNextStep = false
      return
    }

    // 4. Se o paciente tem pendência de cadastro no His...
    if (componentToConfirmReservation === 'BackofficeConfirmarReservaSala' && this.temPendenciaDePaciente) {
      this.loadingNextStep = false
      const message = 'O paciente desta solicitação não está cadastrado no HIS, realize o cadastro clicando em \'BUSCAR PACIENTE\' ou \'ADICIONAR PACIENTE\''
      EventBus.$emit('setSnackbar', { show: true, text: message, icon: 'warning', color: '#C62828' })

      this.$refs.modalContainer.scrollTo({ top: 300, behavior: 'smooth' })
      this.loadingNextStep = false
      return
    }

    // 5. Se o médico tem pendência de cadastro no His...
    if (componentToConfirmReservation === 'BackofficeConfirmarReservaSala' && solicitacao.temPendenciaDeMedico) {
      this.loadingNextStep = false
      const message = 'O médico desta solicitação não está cadastrado no HIS. Por favor, verifique o vínculo do médico.'
      EventBus.$emit('setSnackbar', { show: true, text: message, icon: 'warning', color: '#C62828' })

      this.$refs.modalContainer.scrollTo({ top: (document.querySelector('.backoffice-medico') as HTMLElement).offsetTop, behavior: 'smooth' })
      this.loadingNextStep = false
      return
    }

    // 6. Se hospital faz consulta de cobertura vigente...
    if (solicitacao.hospital!.hospitalFazConsultaCoberturaVigente) {
      const request = await this.getBackofficeGlobalStore.consultaCoberturaVigenteBackoffice()
      if (request.success) this.getBackofficeGlobalStore.setModal({ name: 'erroCoberturaVigente', value: !request.data.temCoberturaVigente })
      if (request.data.temCoberturaVigente) this.getStep = step
      this.loadingNextStep = false
      return
    }

    // 7. Se o próximo passo requer um componente de reserva de sala ou não...
    if ((solicitacao.acoes.agendamentoFazReservaDeSalaParticular && componentToConfirmReservation === 'BackofficeConfirmarReservaSala') || componentToConfirmReservation === 'BackofficeConfirmarReservaSala') {
      this.$refs.refConfirmarTriagem.loadReservaDeSala()
      if (this.opcaoHabilitado('visualizarAgendamentoMedico', 'permitirVisualizarAgendamentosDoMedicoNaTriagem')) {
        await this.getBackofficeMapaCirurgicoGradeStore.getPesquisaGradeMapaCirurgicoWithParams({
          hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId,
          medicoSolicitanteId: this.getBackofficeGlobalStore.solicitacao.medicoSolicitanteId,
        })
      }
    }

    this.getStep = step
    this.loadingNextStep = false
  }

  setStep(step) {
    this.getStep = step
  }

  async showModalCancelamento() {
    this.loadingCancelamento = true
    await timeoutDefault()
    const cancelarSolicitacaoParam: CancelarSolicitacaoParam = {
      solicitacaoId: this.getBackofficeGlobalStore.solicitacao.id,
      tipoOrigem: TipoOrigemEnum.Agendamento,
      situacao: this.getBackofficeGlobalStore.solicitacao.situacao,
      canceladoMotivo: {
        display: '',
        key: '',
      },
      modal: 'triagem',
    }

    if (this.getBackofficeGlobalStore.solicitacao.canceladoMotivo) {
      cancelarSolicitacaoParam.canceladoMotivo = this.getBackofficeGlobalStore.solicitacao.canceladoMotivo
    }

    this.getSolicitacaoCancelamentoStore.setCancelarSolicitacaoParam(cancelarSolicitacaoParam)
    this.getSolicitacaoCancelamentoStore.setShowModalCancelamentoTriagem(true)
    await this.getSolicitacaoCancelamentoStore.getMotivosCancelamentoAll({ hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId })
    this.loadingCancelamento = false
  }

  async showHistory() {
    this.loadingHistorico = true
    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    await this.getHistoricoSolicitacaoStore.getHistoricoSolicitacao(solicitacaoId)
    this.loadingHistorico = false
  }

  async showComentario() {
    this.loadingComentarios = true
    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    await this.getComentariosStore.getComentariosBySolicitacaoId(solicitacaoId)
    this.getComentariosStore.setShowModalComentario(true)
    this.loadingComentarios = false
  }

  async pendencia() {
    this.loadingPendencia = true
    await timeout(800)
    this.showModalPendencia = true
    this.loadingPendencia = false
  }

  get selectedHospitalFromNetwork() {
    const { data } = this.getReservaSalaStore.hospitalSelecionado

    if (data) {
      return {
        name: data.nome,
        id: data.id,
      }
    }

    return null
  }

  get hasHospitalFromNetwork() {
    return this.getReservaSalaStore.hospitaisRede.length > 0
  }

  get hasHospitalFromNetworkAndSelectedHospitalFromNetwork() {
    const { hospitalId: surgerySolicitationHospitalId } = this.getBackofficeGlobalStore.solicitacao

    if (this.hasHospitalFromNetwork
      && this.selectedHospitalFromNetwork
      && this.selectedHospitalFromNetwork.id !== surgerySolicitationHospitalId) {
      return true
    }

    return false
  }

  get equipmentSelectionConfirmed() {
    return this.getBackofficeGlobalStore.equipmentSelectionConfirmed
  }

  set equipmentSelectionConfirmed(confirmed: boolean) {
    this.getBackofficeGlobalStore.setEquipmentSelectionConfirmation(confirmed)
  }

  async confirmarTriagem() {
    this.loadingConfirmar = true

    const { hospitalId: surgerySolicitationHospitalId } = this.getBackofficeGlobalStore.solicitacao

    if (this.hasHospitalFromNetwork && (this.selectedHospitalFromNetwork && this.selectedHospitalFromNetwork.id !== surgerySolicitationHospitalId) && !this.equipmentSelectionConfirmed) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Para prosseguir é necessário verificar os equipamentos da solicitação', icon: 'warning', color: '#C62828' })

      this.loadingConfirmar = false

      return
    }

    if (this.$refs.refConfirmarTriagem.$refs.confirmarTriagemRule.validate()) {
      if (!this.getBackofficeGlobalStore.solicitacao.hospitalFazReservaDeSala) {
        if (await this.$refs.refConfirmarTriagem.checkNumeroReserva()) {
          const response = await this.getBackofficeGlobalStore.finalizarTriagem()
          if (response.success) {
            EventBus.$emit('setSnackbar', { show: true, text: 'Triagem efetuada com sucesso!', icon: 'done', color: '#2E7D32' })
            await this.closeModal()
          } else {
            EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu um erro ao efetuar a triagem.', icon: 'warning', color: '#C62828' })
          }
        }
      } else {
        let isValid: boolean = true

        if (this.getBackofficeGlobalStore.solicitacao.hospital
          && this.getBackofficeGlobalStore.solicitacao.hospital.exigeNumeroReserva) {
          isValid = await this.$refs.refConfirmarTriagem.checkNumeroReserva()
        }

        if (isValid) {
          this.getBackofficeGlobalStore.setNumeroAgendamento(this.getReservaSalaStore.reservaSalaInfo.numeroAgendamento)
          const { id, numeroAgendamento, tempoCirurgia, hospitalFazReservaDeSala, numeroDoAtendimentoAoPacienteNoHospital, numeroDoLeitoDoPacienteInternado } = this.getBackofficeGlobalStore.solicitacao
          const { dateStart, timeStart } = this.$refs.refConfirmarTriagem
          const params: any = {
            salaId: this.getReservaSalaStore.roomChecked.data.id,
            centroCirurgicoId: this.getReservaSalaStore.surgeryCenter.data.id,
            solicitacaoId: id,
            numeroAgendamento: !['', undefined, null].includes(numeroAgendamento) ? numeroAgendamento : '',
            dataAgendamentoVirtual: this.getReservaSalaStore.reservaSalaInfo.dataAgendamentoVirtual,
            data: dateStart,
            hora: timeStart,
            tempoCirurgia,
            hospitalFazReservaDeSala,
          }

          Object.entries(params).forEach(([key, value]) => {
            if (['', null, undefined].includes(value as any)) {
              delete params[key]
            }
          })

          const retornaObjeto = await this.getReservaSalaStore.getTipoObjetoPost(params)

          const pacienteInternadoPayload = {
            numeroDoLeitoDoPacienteInternado: numeroDoLeitoDoPacienteInternado || '',
            numeroDoAtendimentoAoPacienteNoHospital: numeroDoAtendimentoAoPacienteNoHospital || '',
          }

          Object.entries(pacienteInternadoPayload).forEach(([key, value]) => {
            if (['', null, undefined].includes(value as any)) {
              delete pacienteInternadoPayload[key]
            }
          })

          const response = await this.getBackofficeGlobalStore.finalizarReservaSalaTriagem({
            ...retornaObjeto,
            ...pacienteInternadoPayload,
          })

          if (response.success) {
            EventBus.$emit('setSnackbar', { show: true, text: 'Triagem efetuada com sucesso!', icon: 'done', color: '#2E7D32' })
            await this.closeModal()
          } else {
            EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu um erro ao efetuar a triagem.', icon: 'warning', color: '#C62828' })
          }
          this.getBackofficeGlobalStore.setNumeroAgendamento('')
        }
      }
    }

    this.equipmentSelectionConfirmed = false
    this.loadingConfirmar = false
  }

  async backStep(step) {
    this.loadingCloseBtn = true
    this.equipmentSelectionConfirmed = false

    await timeoutDefault()
    if (this.getBackofficeGlobalStore.solicitacao.hospitalFazReservaDeSala && this.getStep === 2) {
      this.$refs.refConfirmarTriagem.$refs.confirmarTriagemRule.resetValidation()
    }
    this.getReservaSalaStore.clearReservaSalasResource()
    this.getReservaSalaStore.clearReservaSalaEvent()
    this.getReservaSalaStore.clearPrecaucoesFromTasy()
    this.getBackofficeMapaCirurgicoGradeStore.clearMedicoSchedule()
    this.getStep = step
    this.loadingCloseBtn = false
  }

  async confirmarPendencia() {
    this.loadingConfirmarPendencia = true

    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    const { mensagens } = this.getPendenciaStore.pendencia
    const response = await this.pendenciaSolicitacao.abrirMensagem(solicitacaoId, mensagens)

    if (response.success) {
      this.getBackofficeAgendamentoStore.deleteSolicitacao(this.getBackofficeGlobalStore.solicitacao.id)
      this.closeModal()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um erro ao enviar a pendência.', icon: 'warning', color: '#C62828' })
    }

    await timeout(2000)
    this.loadingConfirmarPendencia = false
  }

  toggleHtmlOverflow(isOpen: Boolean) {
    const html = document.querySelector('html')
    const noOverflowClass = 'modal-is-open'

    if (html !== null) {
      html.classList.remove(noOverflowClass)
      if (isOpen) {
        html.classList.toggle(noOverflowClass)
        const doc = document.getElementsByClassName('v-dialog')[0]
        if (doc) {
          doc.scrollTop = 0
        }
      }
    }
  }

  scrollToMensagem() {
    const ele = document.getElementsByClassName('scroll_top_triagem')
    if (ele.length > 0) {
      ele[0].scrollTo(0, 0)
    }
  }

  async closeModalCancelamento() {
    this.getBackofficeAgendamentoStore.deleteSolicitacao(this.getBackofficeGlobalStore.solicitacao.id)
    await this.closeModal()
  }

  async closeModal() {
    this.loadingClose = true
    let solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    await this.triagem.desbloquearSolicitacao(this.getBackofficeGlobalStore.solicitacao.id)
    await this.getBackofficeGlobalStore.closeModalTriagem()
    this.getBackofficeGlobalStore.setCoberturaVigenteMensagem('')
    this.getPendenciaStore.clearPendencia()
    this.$refs.refConfirmarTriagem.modalReset()
    this.getStep = 1
    this.loadingClose = false
    this.getReservaSalaStore.clearReservaSalasResource()
    this.getReservaSalaStore.clearReservaSalaEvent()
    this.getReservaSalaStore.resetReservaSalaInfoApi()
    this.getReservaSalaStore.clearSurgeryCenter()
    this.getReservaSalaStore.clearRoomChecked()
    this.getReservaSalaStore.clearCentrosCirurgicos()
    this.getReservaSalaStore.clearPrecaucoesFromTasy()
    this.getReservaSalaStore.clearHospitalSelecionado()
    this.getReservaSalaStore.clearHospitaisRede()

    await this.getBackofficeAgendamentoStore.loadAgendamentosMedicoSearch(solicitacaoId)
    solicitacaoId = ''
    this.getPendenciaStore.setModalConfirmar(false)
    this.getBackofficeMapaCirurgicoGradeStore.clearMedicoSchedule()
    this.showModalConfirmarPendencia = false
    this.getDisableConfirmarTriagem = true
    this.equipmentSelectionConfirmed = false
  }

  async sendMensagem() {
    this.loadingMensagem = true
    await timeoutDefault()

    const time = moment().format('YYYY-MM-DDTHH:mm')
    const pendenciaMensagem: PendenciaMensagem = {
      mensagemHospital: true,
      id: '',
      dataEnvio: time,
      tipoMensagem: TipoMensagemEnum.Texto,
      texto: this.getMensagem,
    }

    this.getPendenciaStore.setPendenciaMensagem(pendenciaMensagem)
    this.getMensagem = ''
    this.loadingMensagem = false
  }

  async inputFileAgendamento(newFile, oldFile) {
    this.loadingUpload = true
    if (newFile.identifier) {
      return
    }

    const form = new FormData()
    form.append('laudos', newFile.file)
    const time = moment().format('YYYY-MM-DDTHH:mm:ss')

    const param: any = {
      hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId,
      tipoDocumento: TipoDocumentoUpload.PendenciaHospital,
      formData: form,
    }

    const response = await this.getPendenciaStore.uploadDocumento(param)

    if (response.success) {
      const result = response.data[0]
      const documentoId = result.id
      const { url } = result
      const { nomeArquivo } = result

      const pendenciaMensagem: PendenciaMensagem = {
        mensagemHospital: true,
        id: documentoId,
        dataEnvio: time,
        tipoMensagem: TipoMensagemEnum.Documento,
        texto: '',
        documentoId,
        url,
        nomeArquivo,
      }

      this.getPendenciaStore.setPendenciaMensagem(pendenciaMensagem)
    }

    this.loadingUpload = false
  }

  clearMensagem() {
    this.getPendenciaStore.clearMensagem()
  }

  async closeModalPendencia() {
    this.loadingClosePendencia = true
    await timeoutDefault()
    this.showModalPendencia = false
    this.loadingClosePendencia = false
  }

  async closeModalConfirmarPendencia() {
    this.loadingCloseConfirmarPendencia = true
    await timeoutDefault()
    this.showModalConfirmarPendencia = false
    this.loadingCloseConfirmarPendencia = false
  }

  dialog: boolean = false
  load: boolean = false
  status: string = ''

  get loading() {
    return this.load
  }

  set loading(value: boolean) {
    this.load = value
  }

  get showModalInvalidarAssinatura() {
    return this.dialog
  }

  set showModalInvalidarAssinatura(value: boolean) {
    this.dialog = value
  }

  closeModalInvalidarAssinatura() {
    this.showModalInvalidarAssinatura = false
  }

  setDialogStatus() {
    if (this.status === 'pendenciaAberta') {
      return { color: 'green darken-2', icon: 'check_circle', message: 'Pendência aberta para o médico!' }
    }

    if (this.status === 'erro') {
      return { color: 'red darken-2', icon: 'report_problem', message: 'Ocorreu um erro ao invalidar assinatura' }
    }

    return { color: 'indigo darken-2', icon: 'mdi-format-color-marker-cancel', message: 'Invalidar assinatura' }
  }

  async invalidarAssinatura() {
    const msg: string = `
      Para dar prosseguimento ao processo, favor refazer a sua assinatura.
      1. No seu celular acesse a plataforma https://www.portalfinx.com.br
      2. Em seguida acesse o menu Perfil e Assinatura.
      3. Escreva na tela a sua Assinatura.
      4. E depois confirme.
    `
    this.loading = true
    this.getMensagem = msg
    await this.sendMensagem()
    this.status = 'pendenciaAberta'
    // this.status = 'erro'
    await timeout(2000)
    this.loading = false
    this.status = ''
    this.closeModalInvalidarAssinatura()
  }

  get temPendenciaDePaciente() {
    return this.getBackofficeGlobalStore.solicitacao.temPendenciaDePaciente
  }

  disablePendenciaPaciente: boolean = true

  get disabledPendenciaPaciente() { return this.disablePendenciaPaciente }
  set disabledPendenciaPaciente(value: boolean) { this.disablePendenciaPaciente = value }

  @Watch('temPendenciaDePaciente')
  onChangeTemPendenciaDePaciente(value) {
    this.disabledPendenciaPaciente = !!value
  }

  opcaoHabilitado(prop1: string, prop2: string) {
    if (this.getBackofficeGlobalStore.template.formulario) {
      const response = this.getBackofficeGlobalStore.template.formulario[prop1]
        && this.getBackofficeGlobalStore.template.formulario[prop1].campos
        && this.getBackofficeGlobalStore.template.formulario[prop1].campos[prop2]
      return response
    }

    return false
  }

  /** Pesquisa de médico */

  medicoScheduleTableHeaders: any[] = [
    { text: 'Paciente', class: 'table-headers-grey', align: 'left', value: 'pacienteNome' },
    { text: 'Médico', class: 'table-headers-grey', align: 'left', value: 'medicoNome' },
    { text: 'Caráter da cirurgia', class: 'table-headers-grey', align: 'center', value: 'carater' },
    { text: 'Sala cirúrgica', class: 'table-headers-grey', align: 'left', value: 'salaCirurgicaNome' },
    { text: 'Data e hora', class: 'table-headers-grey', align: 'center', value: 'horario' },
    { text: 'Status', class: 'table-headers-grey', align: 'left', value: 'solicitacaoStatusSituacao' },
  ]

  get medicoSchedule() {
    return this.getBackofficeMapaCirurgicoGradeStore.medicoSchedule
  }

  caraterCirurgiaMapUtil(value: string) {
    return caraterCirurgiaMap.get(value)
  }

  maskDateTimeUtil(value: string) {
    return maskDateTime(value)
  }

  solicitacaoStatusSituacaoMapUtil(value: string) {
    return solicitacaoStatusSituacaoMap.get(value)
  }

  windowWidth: number = 0
  getWindowWidth() {
    this.windowWidth = document.documentElement.clientWidth
  }

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })

    EventBus.$on('disabledConfirmarTriagem', (value: any) => { this.getDisableConfirmarTriagem = value })
    EventBus.$on('abrirPendenciaAutomatica', (value: string) => {
      if (value === 'triagem') {
        this.showModalPendencia = true
        this.getMensagem = this.getBackofficeGlobalStore.coberturaVigenteMensagem
      }
    })
    EventBus.$on('limparPendenciaAutomatica', (value: boolean) => this.getBackofficeGlobalStore.setCoberturaVigenteMensagem(''))
  }

  updated() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  }
}
